import { useEffect, useState } from "react";
import { styled } from "styled-components";
import { Step, StepLabel, Stepper } from "@mui/material";
import { animateScroll } from "react-scroll";
import StepContainer from "./StepContainer";
import invoicesApi from "../../api/user/invoices";
import Step1 from "./Step1";
import Step3 from "./Step3";
import Step4 from "./Step4";
import { toast } from "react-toastify";
import Step2 from "./Step2";

const steps = ["Review", "Information", "Delivery", "Confirmation"];

const PaymentForm = ({ service }) => {
  const [activeStep, setActiveStep] = useState(1);
  const [payload, setPayload] = useState({
    websiteUrl: "",
    serviceType: "PDF Sent to Email",
    loading: false,
  });

  useEffect(() => {
    animateScroll.scrollToTop();
  }, [activeStep]);

  const handleConfirmOrder = () => {
    setPayload({
      ...payload,
      loading: true,
    });

    invoicesApi
      .createInvoice(
        service.price,
        service.title,
        payload.serviceType,
        payload.websiteUrl
      )
      .then((res) => {
        const { paymentLink } = res.data;
        window.location.replace(paymentLink);
      })
      .catch((err) => {
        const message =
          err?.response?.data?.message?.en ||
          err.message ||
          "Something went wrong.";
        toast.error(message);
        setPayload({
          ...payload,
          loading: false,
        });
      });
  };

  const handleKeyChange = (key) => (event) => {
    const value = event?.target?.value?.trim?.() || event;
    setPayload({
      ...payload,
      [key]: value,
    });
  };

  const handleNext = (e) => {
    try {
      const nextStep = activeStep + 1;
      if (nextStep <= steps.length) {
        setActiveStep(nextStep);
      }
    } catch (err) {}
  };

  const handlePrev = () => {
    try {
      const prevStep = activeStep - 1;
      if (prevStep >= 1) {
        setActiveStep(prevStep);
      }
    } catch (err) {}
  };

  return (
    <Container>
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map((label, index) => (
          <StyledStep
            key={label}
            active={activeStep === index + 1}
            completed={activeStep > index + 1}
            // onClick={() => setActiveStep(index + 1)}
            onClick={() => {}}
          >
            <StepLabel>
              {label}{" "}
              {/* {index === 1 && (
                <>
                  <br />
                  <span>(Optional)</span>
                </>
              )}{" "} */}
            </StepLabel>
          </StyledStep>
        ))}
      </Stepper>

      {activeStep === 1 && (
        <StepContainer
          title="Service Review"
          disablePrev={activeStep === 1}
          disableNext={activeStep === steps.length}
          lastStep={activeStep === steps.length}
          onNext={handleNext}
          onPrev={handlePrev}
        >
          <Step1 service={service} />
        </StepContainer>
      )}

      {activeStep === 2 && (
        <StepContainer
          title="If you need this service for an existing website or application, please provide us with the following information:"
          disablePrev={activeStep === 1}
          disableNext={activeStep === steps.length}
          lastStep={activeStep === steps.length}
          onNext={handleNext}
          onPrev={handlePrev}
        >
          <Step2
            websiteUrl={payload.websiteUrl}
            onWebsiteUrlChange={handleKeyChange("websiteUrl")}
          />
        </StepContainer>
      )}

      {activeStep === 3 && (
        <StepContainer
          title="How would you like to receive this service?"
          disablePrev={activeStep === 1}
          disableNext={activeStep === steps.length}
          lastStep={activeStep === steps.length}
          onNext={handleNext}
          onPrev={handlePrev}
        >
          <Step3
            serviceType={payload.serviceType}
            onServiceTypeChange={handleKeyChange("serviceType")}
          />
        </StepContainer>
      )}

      {activeStep === 4 && (
        <StepContainer
          title="Confirm your order details"
          disablePrev={activeStep === 1}
          disableNext={activeStep === steps.length}
          lastStep={activeStep === steps.length}
          onNext={handleNext}
          onPrev={handlePrev}
          onConfirmOrder={handleConfirmOrder}
          loading={payload.loading}
        >
          <Step4 service={service} order={payload} />
        </StepContainer>
      )}
    </Container>
  );
};

const Container = styled.div`
  margin-top: 3rem;
`;

const StyledStep = styled(Step)`
  cursor: pointer;

  svg {
    font-size: 40px !important;

    &.Mui-active,
    &.Mui-completed {
      fill: #ff6341 !important;
    }

    @media screen and (max-width: 480px) {
      font-size: 32px !important;
    }
  }

  .MuiStepConnector-line.MuiStepConnector-lineHorizontal {
    margin: 0 15px !important;
    margin-top: 4px !important;
  }

  .MuiStepLabel-label {
    font-size: 15px !important;
    font-weight: 600 !important;

    span {
      font-size: 11px;
      font-weight: 600;
      color: #747474;
    }
  }
`;

export default PaymentForm;
